// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__o0a7C","rootNoMargin":"styles_rootNoMargin__2ncoC"};